import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function Button({
  children,
  className = '',
  onClick,
  href,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative group overflow-hidden rounded-lg bg-brand-orange px-8 py-4 
        text-lg font-bold text-white shadow-glow transition-all 
        hover:shadow-glow-lg hover:bg-orange-500 cursor-pointer
        ${className}
      `} {...props} data-id="element-193">
      <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-194" />
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-195">
        {children}
      </span>
    </motion.button>;
}